import { Component, OnInit } from '@angular/core';
import {ValidateService} from '../../services/validate.service';
import {AuthService} from '../../services/auth.service';
import {FlashMessagesService} from 'angular2-flash-messages';
import {Router} from '@angular/router';

@Component({
  selector: 'app-suscribe',
  templateUrl: './suscribe.component.html',
  styleUrls: ['./suscribe.component.css']
})
export class SuscribeComponent implements OnInit {

	prenom: String;
  nom : String; 
  email: String;
  centre : String; 
  password : String; 

  constructor(
   private validateService : ValidateService, 
   private flashMessagesService : FlashMessagesService,
   private authService: AuthService,
   private router :Router
    ) { }

  ngOnInit() {
  }


  onSuscribeSubmit(){

  const user = {

  prenom : this.prenom,
  nom : this.nom,
  email : this.email,
  centre : this.centre,
  password : "testdjiddou" //Math.random().toString(36).substr(2, length)
  

  }


	if(!this.validateService.validateSuscribe(user)){
	this.flashMessagesService.show('svp veuillez verifier tous les champs',{cssClass:'alert-danger',timeout:3000});
	return false;
		
	}
	if(!this.validateService.validEmail(user.email)){
	this.flashMessagesService.show('svp veuillez utiliser un email valide',{cssClass:'alert-info',timeout:3000});
	
} 

// suscribe user
  this.authService.suscribeUser(user).subscribe(data =>{
  if(data.success){
    this.flashMessagesService.show('vous vous etes inscrit avec succes',{cssClass:'alert-success',timeout:3000});

    this.router.navigate(['/login']);

  } else{
    this.flashMessagesService.show('Linscription na pas reussie veuillez reessayer plus tard ',{cssClass:'alert-danger',timeout:3000});
      this.router.navigate(['/suscribe']);

  }
  });

  }

}



// WEBPACK FOOTER //
// ./src/app/components/suscribe/suscribe.component.ts